module.exports = __webpack_public_path__ + "static/media/dl4j.a472f200.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backends/dl4j.svg
// module id = 318
// module chunks = 0